import moment from 'moment'
import api from './api';
import history from '../containers/history'
import { signOut } from "../redux/action/main";


class UtilityService{

    baseUrl() {
      //  return 'http://180.151.69.138:2034/' //staging
      //  return 'http://192.168.10.167:2024/' //janen
     // return 'http://192.168.10.121:2024/' //raunik
     // return 'http://192.168.10.173:2009/'
     return api.base_url
     
    }

    fileUrl () {
        return "https://magnum-clothing.s3.ap-south-1.amazonaws.com/"
    }

    authToken() {
        return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsYXN0TG9nZ2VkSW4iOiIyMDE4LTA1LTA4VDA3OjMwOjExLjE0OFoiLCJfaWQiOiI1YWUxYjQ3ZDZlZDIzYTIyOGU4ZGM0ZjQiLCJpYXQiOjE1MjU3NjQ2MTF9.pf3voSSp2j773cHLop_0a1bqpcIjOTimGs2jKMi15cU'
        //return 'http://192.168.10.173:2009/'
    }

    successMsg(msg,msgText,time){
        msgText =  msgText ? msgText : "Successfully Added"
        msg.show(msgText, {
            time: time?time:2000,
            type: 'success'
        })
    }
    warningMsg(msg,msgText,time){
        msgText =  msgText ? msgText : "Entry already exists"

        msg.show(msgText, {
            time: time ? time : 2000,
            type: 'info'
        }) 
    }
    errorMsg(msg,msgText,time) {
        msgText =  msgText ? msgText : "Error Occurred!!!"
        if(msg !== undefined){
            msg.show(msgText, {
                time: time ? time : 2000,
                type: 'error'
            })            
        }

    }

    manualErrorMsg(msg,msgString,time) {
        if(msg !== undefined){
            msg.show(msgString, {
                time: time ? time : 2000,
                type: 'error'
            })
        }
    }

    editMsg(msg) {
        msg.show("Successfully Edited", {
            time: 2000,
            type: 'success'
        })
    }
    deleteMsg(msg,msgText,time) {
        msgText = msgText ? msgText : "Successfully Deleted"
        msg.show(msgText, {
            time: time ? time : 2000,
            type: 'info'
        })
    }
    completeMsg(msg,time){
        msg.show("Successfully Completed", {
            time: time ? time : 2000,
            type: 'info'
        })
    }

    infoMsg(msg,msgString,time){
        msg.show(msgString,{
            time: time ? time : 2000,
            type: 'info'
        })
    }

    fetchHandler(response) {
        if (response.ok) {
            return response.json().then(json => {
                // the status was ok and there is a json body
                return Promise.resolve({json: json, response: response});
            }).catch(err => {
                // the status was ok but there is no json body
                return Promise.resolve({response: response});
            });
    
        } else {
            return response.json().catch(err => {
                // the status was not ok and there is no json body
                throw new Error(response.statusText);
            }).then(json => {
                // the status was not ok but there is a json body
                throw new Error(json.error.message); // example error message returned by a REST API
            });
        }
    }

    parseIntegerToTime(time){
        let videoTime = parseInt(time, 10);
        videoTime = [parseInt(((videoTime / 60) % 60), 10), parseInt(videoTime % 60, 10)].join(':').replace(/\b(\d)\b/g, '0$1');
        return videoTime;
    }

    secondsToHours(seconds){
        return [parseInt(seconds / 60 / 60, 10), parseInt((seconds / 60) % 60, 10), parseInt(seconds % 60, 10)].join(':').replace(/\b(\d)\b/g, '0$1');
    }

    displayDate(timestamp) {
        var unixtime = timestamp;
        var newDate = new Date();
        newDate.setTime(unixtime * 1000);
        var dateString = newDate.getDate() + '/' + (newDate.getMonth() + 1) + '/' + newDate.getFullYear() + ' ' + this.formatAMPM(newDate);
        return dateString;
    }

   

    getDateAndTime(date){
        let newDate = new Date(date);
        return newDate = newDate.toString().substring(4, 24);
    }

    convertTimeToSec(value){
        let a = value.split(":")
        let totalSeconds = parseInt(a[0] * 3600,10) + parseInt(a[1] * 60,10) + parseInt(a[2],10)
       return parseInt(totalSeconds ,10)
    }

    round(value) {
        return Number(Math.round(value+'e2')+'e-2');
    }

    get geturlparam(){
        return window.location.pathname.split('/')
    }

    getCurrentTimeDuration(dateAndtime){
        let offset = moment().utcOffset();
        let getCurrentLocalTime = moment.utc(dateAndtime).utcOffset(offset).format();
        return  moment(getCurrentLocalTime, "YYYY-MM-DD hh:mm:ss +ZZ").fromNow()
    }

    
    async imageUpload(value) {
        
        var formData = new FormData();
        // formData.append("refImage",value)
        for (let i = 0; i < value.length; i++) {
            formData.append("referenceImages", value[i])
        }
        let result = await fetch(this.baseUrl() + 'api/development/uploadReferenceImages', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: formData
        });
        return result.json();
    }

    async getUserInfo() {
        let result = await fetch(this.baseUrl() + 'api/employee/profile', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return { 
            status : result.status,
            text : await result.json()
        };
    }

    
    async updateProfile(data) {
       
        let result = await fetch(this.baseUrl() + 'api/employee/profile', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status : result.status,
            text : await result.json()
        };
    }

    async getAuditInfo(id) {
        let url = (id !== "bulkImport") ? 'api/modulesLogs/getModuleLogs/'+id : 'api/modulesLogs/getModuleLogFabBulk'
        let result = await fetch(this.baseUrl() + url, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return { 
            status : result.status,
            text : await result.json()
        };
    }

    async getImageType() {
        let url = 'api/system/getSystemGenImages'
        let result = await fetch(this.baseUrl() + url, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return { 
            status : result.status,
            text : await result.json()
        };
    }

    
    unauthorisedFunc = () => {
        localStorage.removeItem("authToken");
        localStorage.clear();
        signOut();
        history !== undefined && history.push("/");
    };
   
}

export default new UtilityService();

export const getFixedTwo = (num) => {
    return Number(num).toFixed(2)
}


// WEBPACK FOOTER //
// ./src/services/utility.service.js